import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import HeaderCarselect from './component/header/HeaderCarselect';
import { getCollection } from './utils/helper';
import { AppContext } from './appContext';
import LandingPage from './home/LandingPage';
import FooterTwo from './component/footer/FooterTwo';
import { Route, Routes } from 'react-router-dom';
import DetailingPage from './home/DetailingPage';

const App = () => {
  //#region Get dictionaries from context
  const {
    lang,
    setLang,
    dictionaries,
    setDictionary,
    setDictionaries,
    setDefaultDictionary,
  } = useContext(AppContext);

  useEffect(() => {
    getCollection('dictionaries')
      .then((dictionaries) => {
        setDictionaries(dictionaries[0].dictionaries);

        const defaultDictionary = dictionaries[0].dictionaries.find(
          (dict) => dict.name === 'ua',
        );

        setDefaultDictionary(defaultDictionary);

        const selectedLang = localStorage.getItem('lang');

        if (selectedLang) {
          const currentDictionary = dictionaries[0]?.dictionaries?.find(
            (dict) => dict.name === selectedLang,
          );
          setLang(selectedLang);
          setDictionary(currentDictionary);
        } else {
          setDictionary(defaultDictionary);
        }
      })
      .catch((error) => console.log(error));
  }, []);

  //#endregion

  const [isMainPage, setIsMainPage] = useState(true);

  //#region Render
  return (
    <div className='App'>
      <>
        <HeaderCarselect
          isMainPage={isMainPage}
          setIsMainPage={setIsMainPage}
        />

        <Routes>
          <Route index element={<LandingPage />} />

          <Route
            path={'/detailing/*'}
            element={<DetailingPage setIsMainPage={setIsMainPage} />}
          />
        </Routes>

        <FooterTwo />
        {/*<button*/}
        {/*      type={'button'}*/}
        {/*      onClick={() => {setDocumentToCollection('dictionaries', {dictionaries: [ukrainianDictionary, russianDictionary, czechDictionary]})}}*/}
        {/*  >*/}
        {/*      save*/}
        {/*  </button>*/}
      </>
    </div>
  );
};

export default App;
